<div class="container">

  <mat-tab-group>
    <mat-tab label="Channel">
      <hr>
      <form class="example-form" (ngSubmit)="onSubmit(f)" #f="ngForm">

        <div class="input-group mb-3">
          <div>
            <img  class="product-image" [src]="channel.imageUrl" alt="">
          </div>
          <mat-card appearance="outlined" class="example-card" *ngIf="channel.productId; else noProduct">
            <mat-card-header>
              

              <mat-card-title *ngIf="channel.productNumber">
                {{channel.productNumber}}
              </mat-card-title>
              <mat-card-subtitle *ngIf="channel.name">
                
                <a style="cursor: pointer;" (click)="editProductPopup(channel.productId)">{{channel.name.length>50 ?
                  (channel.name | slice:0:50)+'....' : channel.name}}</a>
              </mat-card-subtitle>
            </mat-card-header>
          </mat-card>
          <button *ngIf="channel.productId && auth.canEdit(this.auth.user$ | async)" mat-button color="warn"
            type="button" (click)="deAttachProduct(channel);">
            De-Attach
          </button>
          <ng-template #noProduct>
            <input type="text" class="form-control" value="No Product Connected" disabled
              aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default">
          </ng-template>
        </div>



        <mat-form-field class="example-full-width">

          <input type="text" placeholder="Change Product" required aria-label="Number" matInput
            (keyup)="applyFilter($event.target['value'])" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">

            <mat-option *ngFor="let option of filteredOptions | async" (click)="onSelectProduct(option)"
              value="{{option.name}}">

              <img class="example-option-img" aria-hidden *ngIf="option.imageUrl" [src]="option.imageUrl" height="25">
              <span>{{option.productNumber}} - {{option.name}}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <img [src]="selectedProductImage" alt="" style="max-height:60px">

        <button class="theme-button" *ngIf="auth.canEdit(this.auth.user$ | async)" [disabled]="!f.valid" type="submit">
          Save
        </button>
      </form>

    </mat-tab>
    <mat-tab label="Configuration">
      <hr>
      <form class="example-form" (ngSubmit)="onSubmit2(g)" #g="ngForm">

        <mat-form-field class="example-full-width" *ngIf="hasStockingAccess && productTypeKeys.length">
          <mat-label>Product Type</mat-label>
          <mat-select name="productType" [(ngModel)]="channel.productType">
            <mat-option [value]="null">-- None --</mat-option>
            <mat-option *ngFor="let key of productTypeKeys" [value]="key">
              {{key}} ({{productTypes[key]}})
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="input-group mb-3" *ngIf="!hasStockingAccess && channel.productType">
          <div class="input-group-prepend">
            <span class="input-group-text">Product Type</span>
          </div>
          <input type="text" class="form-control" [value]="channel.productType" disabled>
        </div>

        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-default">Selection</span>
          </div>
          <input type="number" class="form-control" aria-label="Sizing example input"
            [(ngModel)]="channel.selection" name="selection" id="selection"
            aria-describedby="inputGroup-sizing-default">
        </div>


        <!-- <div class="input-group mb-3" >
        <div class="input-group-prepend">
          <span class="input-group-text" id="inputGroup-sizing-default">
            Extraction Time
          </span>
        </div>
        <mat-slider thumbLabel step="0.1" min="0" max="10" [(ngModel)]="channel.extractionTime" name="extractionTime"
          id="extractionTime"><input matSliderThumb />
        <input type="text" class="form-control" disabled [formControl]="channel.extractionTime"
          aria-label="Sizing example input"  id="extractionTime" aria-describedby="inputGroup-sizing-default">
        </mat-slider>
        </div> -->

        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-default">
              Extraction Time
            </span>
          </div>
          <mat-slider class="example-margin" max="2" min="0" step="0.1">
            <input matSliderThumb name="extractionTime" [(ngModel)]="channel.extractionTime" #slider>
          </mat-slider>

          <input type="text" class="form-control" disabled name="extractionTime" [value]="channel.extractionTime"
            id="extractionTime">
        </div>

        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-default">
              Voltage
            </span>
          </div>
          <mat-slider class="example-margin" disabled max="9" min="0" step="1">
            <input matSliderThumb name="voltage" [(ngModel)]="channel.voltage" #slider>
          </mat-slider>

          <input type="text" class="form-control" disabled name="voltage" [value]="channel.voltage" id="voltage">
        </div>
        <button class="theme-button" *ngIf="auth.canEdit(this.auth.user$ | async)" [disabled]="!f.valid" type="submit">
          Save
        </button>
      </form>
    </mat-tab>
  </mat-tab-group>
  <hr>
  <!-- Shown/hidden with showTestChannel (sends channelVending over MQTT). -->
  <ng-container *ngIf="showTestChannel && auth.canPerformActions(this.auth.user$ | async)">
    <button class="theme-button" [disabled]="isSoldOut" (click)="testChannel()">
      Test channel
    </button>
    <small class="test-channel-note" *ngIf="isSoldOut">
      This channel is marked sold out, so it cannot be tested. Reset sold out on the machine first.
    </small>
  </ng-container>
</div>